import { deepCompare } from '../utils/index.js';

function isEqualState(a, b) {
    return deepCompare(a, b);
}

export { isEqualState };
